module.exports = __webpack_public_path__ + "img/hos2.f56e6885.png";